module.exports = __webpack_public_path__ + "img/global-developing.png?e8bf23b9";